import { withTheme } from '../config';
import { Tooltip } from '@rneui/base/dist/Tooltip/Tooltip';
export { Tooltip };
export default withTheme(Tooltip, 'Tooltip');
